import React from 'react';
import { formatEventDate } from '../utils/events.js';
import { brandText } from './BrandText.jsx';

// One row per event: the date in the visitor's language, the title (a link
// when the event has a page) and the description from the language file.
const EventList = ({ events, texts, language }) => (
  <div className="site-row-list">
    {events.map((event) => {
      const text = texts?.[event.id];
      if (!text) return null;

      return (
        <article className="site-row site-row--text event-row" key={event.id}>
          <p className="event-row__date">
            <time dateTime={event.date}>{formatEventDate(event, language)}</time>
          </p>
          <div>
            <h3>
              {event.url
                ? <a href={event.url} target="_blank" rel="noopener noreferrer">{text.title}</a>
                : text.title}
            </h3>
            <p>{brandText(text.description)}</p>
          </div>
        </article>
      );
    })}
  </div>
);

export default EventList;
